import Icons from '../../images/icons.svg?react';
import styled from 'styled-components';

export const IconsSource = styled(Icons)`
  display: none;
`;
